import BasePositional from '../BasePositional';

const Base = ({id, nodeRef, ...props}) => (
    <BasePositional id={id} {...props}>
        <div className={`${id}-marker`} ref={nodeRef} />
    </BasePositional>
);

export default Base;
